import * as React from "react";
import { useEffect, useState, } from "react";
import { getActionableDocuments } from "shared/services/railDocumentsApi";
import { useNavigate } from "react-router-dom"
import { Button, Card } from 'reactstrap';
import { AnnouncementOutlined, KeyboardArrowRightOutlined } from '@mui/icons-material';
import Documents from "./DocumentGrid"
import './grid-cards.css'
import { RailDocument } from "../../shared/models/api/models";
import { AwaitingActionFilterTraditional, AwaitingActionFilterCBTC } from "../ui/DocumentRules";
import { RulebookModeEnum, RulebookNameToEnum } from "../../shared/enums/rulebook-mode-enum";
import { getUserExistingRulebookMode } from "../../shared/store/applicationState";

const MyActions = (props: { maxResults: number }) => {
    const [documents, setDocuments] = useState(null as RailDocument[] | null);
    const navigate = useNavigate();

    const mode = getUserExistingRulebookMode();
    let goToMyAwaitingActionList;
    if (RulebookNameToEnum(mode) === RulebookModeEnum.Traditional) {
        goToMyAwaitingActionList = () => navigate(AwaitingActionFilterTraditional.url);
    } else if (RulebookNameToEnum(mode) === RulebookModeEnum.CBTC) {
        goToMyAwaitingActionList = () => navigate(AwaitingActionFilterCBTC.url);
    } else {
        console.log('Redirection to RailRulebookDocumentModule failed - document mode is not set');
    }

    let downloadedDocuments = null as RailDocument[] | null;
    const updateDocuments = async () => {
        downloadedDocuments = await getActionableDocuments(mode!);
    }

    const documentListModalsClosed = () => {
        if (downloadedDocuments !== null && downloadedDocuments.length > 0) {
            const docs = downloadedDocuments;
            setDocuments(docs);
            downloadedDocuments = null;
        }
    }

    useEffect(() => {
    }, [downloadedDocuments]);

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const mode = getUserExistingRulebookMode()
            const items = await getActionableDocuments(mode!);

            if (mounted) {
                setDocuments(items);
            }
        };

        mount();
        return () => { mounted = false };
    }, []);

    const View = () => {
        const navigate = useNavigate();

        const [selectedItems, setSelectedItems] = useState([] as number[]);

        const clearSelectedItems = () => {
            setSelectedItems([] as number[]);
        };

        const documentButtonAction = (docId: number) => {
            let mode = getUserExistingRulebookMode();
            if (mode == 'cbtc') {
                mode = 'mbs';
            }
            navigate(`/pdf/view/${mode}/${docId}`);
        };

        return (
            <div className="document-container">
                <Documents
                    documents={documents}
                    onDataChanged={updateDocuments}
                    onModalsClosed={documentListModalsClosed}
                    pageSize={props.maxResults}
                    hidePageList={true}
                    selectedItems={selectedItems}
                    clearSelected={clearSelectedItems}
                    documentButtonAction={documentButtonAction}
                    noDocumentsMessage="There are no actionable documents to display."
                    hiddenColumns={["Status", "Select"]} />
            </div>
        );
    };

    return (
        <Card className="secondary-card">
            <span className="secondary-card-heading" >
                <AnnouncementOutlined fontSize="inherit" />
                <span className="pl-4">My actionable documents</span>
                {documents &&
                    <span onClick={goToMyAwaitingActionList} className="pl-5 result-count clickable">
                    {
                        documents?.length > props.maxResults
                        ? props.maxResults
                            : documents.length
                    } of {
                        documents.length
                    } result{documents.length > 1 ? "s" : ""}
                        <KeyboardArrowRightOutlined className="more-results-arrow" />
                    </span>
                }
                {!documents &&
                    <span className="pl-5 result-count">Loading...</span>
                }
            </span>
            <View />
            <div className="pb-3" style={{ display: 'flex', justifyContent: 'center' }}>
                <Button className="btn-primary" onClick={goToMyAwaitingActionList}>Go to My Documents</Button>
            </div>
        </Card>
    );
}

export default MyActions;
